import { render, staticRenderFns } from "./StartCompanyItem.vue?vue&type=template&id=315c5978&scoped=true&"
import script from "./StartCompanyItem.vue?vue&type=script&lang=ts&"
export * from "./StartCompanyItem.vue?vue&type=script&lang=ts&"
import style0 from "./StartCompanyItem.vue?vue&type=style&index=0&id=315c5978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315c5978",
  null
  
)

export default component.exports